// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';

//Third Party
import moment from 'moment';
//import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Config/Globals
import { Enums } from '../../shared/enums.js';
    
//Auth & Config
import { authToken } from '../../shared/authToken';
import { FormAction } from '../../shared/classes/formAction';
//import { setTimeout } from 'timers';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
@Component({
    template : '<div class="nar-main-div" data-test-id="content_narratives">\n\n    <!--Title-->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n    <div style="margin:0 10px 5px 20px; font-style:italic">Select an asset to review its narratives.</div>\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <ng-template #loading>\n        <div class="nar-ui-content-loading">\n            <img src="public/cpd-images/loading.gif" />\n            <div style="margin-left:10px;">Loading...</div>\n        </div>\n    </ng-template>\n   \n    <!--Content Div -->\n    <div *ngIf="!_isLoading(); else loading" class="nar-ui-row" style="flex-grow:1;">\n\n        <!-- Practice Grid --------------------------------->\n        <cas-grid #practicesGrid\n                    summary="{{_title}} List"\n                    [settings]="practicesGridSettings"\n                    (onRefreshClicked)="onGridRefreshClicked()"\n                    (onRowSelectionChanged)="onRowSelectionChanged()"\n                    (onPageChanged)="onPageChanged($event)"\n                    (onSearch)="onGridSearch($event)"\n                    (onSort)="onSort($event)">\n            <!--(onSettingsClicked)="gridSettingsSelected($event)"-->\n        </cas-grid>\n\n    </div>\n\n\n</div>\n\n\n\n\n\n\n\n',
    styles : ['.nar-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.nar-ui-row{position:relative;margin:0 0px 5px 0px;border-top:solid 1px #ccc}.nar-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.nar-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #ccc}.nar-ui-row{position:relative;margin:0 0px 5px 0px;border-top:solid 1px #b8b8b8}.nar-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:10px 15px 5px 15px;margin:0 10px}.nar-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.nar-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #b8b8b8}.nar-cssClasses_Grid{border-top:solid 1px #bbb}'],
    providers:[ ],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class NarrativesComponent {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    //@ViewChild('narrativesGrid') narrativesGrid;
    @ViewChild('practicesGrid') practicesGrid;
    
	//Class wide member reference for the growls control
	growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _allFieldsDisabled = false;
    _componentName = 'narratives.js';
    _disposalFunctions = [];
    _formName = "narratives";
    _loading = true;
    _sessionStorageObject = null;
    _title = "";
    //_now = moment();
    
    //Grid settings
    practicesGridSettings = {
        //rowsPerPage : 25,
        hideClearSelectedButton:true,
        hideSearchBox:false,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"practice_code",
        rowIdentityPrefixForJAWS:"Asset Code",
        showCheckboxColumn:true,
        positionAbsolute:true,
        //cssClasses_Grid:"nar-cssClasses_Grid",

        columns : [
            //{ fieldName:'practice_id', display:'pid', width:'10%' },
            { fieldName:'practice_code', display:'Asset Code', width:'20%' },
            { fieldName:'practice_name', display:'Asset Name', width:'55%' },
            { fieldName:'narrative_count', display:'Total Narratives', width:'25%' },
            { fieldName: 'action_required', display: 'Action Required', width: '10%' }
        ],
        rows : []
    }

    //An event listener handler method that will have "this" prebound so removeListener will work (which can't handle
    //removing a listener if it was bound in the registration)
    _boundKeypressHandler = null;


    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService, 
        cpdFormatters: CPDFormatters,
        ngbDateParser: casNgbDateParserFormatter,
        //formDataService: FormDataService2,
        helpers: Helpers,
        router:Router,
        webServices: WebServices){

        this.constructor.mapParams( this, arguments );

		// Growl Prep
		//--------------------
		this.growlBox = new BCGrowls("growlBox");
		this.growlBox.init({ 
			appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
		}); 


        //Init the local storage for this page
        this._sessionStorageObject = this._loadSessionStorageObject();

        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedPracticeId:null,
                currentPage:1,
                sortColumn:null,
                sortDirection:null
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }
        
        //Handle nav menu events
        this._disposalFunctions.push( casNavBoxService.OnActionClicked$.subscribe( action => {
            this.NavBoxActionClicked(action);
        }));

        //Set the title
        this._title = this._getTitle();


        // Debugging
        //-------------------------------------------
        casNavBoxService.ClearDebugEntries();
        casNavBoxService.DebugEntries.push("Dump Session Storage");
        let disposer = casNavBoxService.OnDebugEntryClicked$.subscribe( entry => {
            this._debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);

        //Keypress Handler
        //-------------------------------------------
        //Prebind the listener (not using this here, keep for later)
        //this._boundKeypressHandler = this._handleGlobalKeypress.bind(this);

        //Register the handler globally to keyup
        window.addEventListener("keyup", this._boundKeypressHandler);

    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        this._disposalFunctions.map( x => x.unsubscribe() );
        window.removeEventListener("keyup", this._boundKeypressHandler);
    }
    
    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){
        this.set508();
        this.setNavBoxActions();
        this.LoadPractices();
    };

    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {

        let actions = [];
        actions.push(new FormAction("act_view_narrative", "View Narratives"));
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;

        //switch (authToken.user.role) {

        //    case Enums.Roles.NHQNationalPracticeDataSteward.id:
        //    case Enums.Roles.StateDataSteward.id:
        //    case Enums.Roles.NationalDisciplineDataSteward.id:
        //    case Enums.Roles.DataViewer.id:
        //        actions.push(new FormAction("act_view_narrative", "View Narratives"));
        //        break;
        //}
    }

    //==================================
    // LoadPractices
    //==================================
    LoadPractices(){

        //Even after ngAfterViewInit, the viewchildren still aren't defined (angular sucks).
        if (this.practicesGrid){
            this.practicesGrid.MarkAsLoading(true);
        }
        else{
            this.practicesGridSettings.loading = true;
        }


        //NEW ------------------------------------
        this.webServices.Get({
            apiPath: "/practices/getPracticesListByRoleV2",
            args: {
                filter: "futureActive",
                assetTypeCode: ""
            }
        })
        .then(res => {
            console.log("[{0}:/practices/getPracticesListByRoleV2] - res:".format(this._componentName), res);

            this._markPageAsLoading(false);
            this._markGridAsLoading(false);
            this._setGridRows(res.data.DTO);
            //this._sortGrid("practice_name", "A");

            //Wait for the grid to be rendered and then apply any session selections
            this.helpers.executeOnCondition(

                //When the grid is rendered...
                () => { return !!this.practicesGrid; },
                
                //Do this
                () => {  

                    //Apply a sort
                    this.practicesGrid.SortGrid(
                        this._sessionStorageObject.sortColumn || "practice_name", 
                        this._sessionStorageObject.sortDirection || "A"
                    );

                    //Check to see if we have a stored page to return to
                    if (this._sessionStorageObject.currentPage) {
                        if (!this.practicesGrid.SetPage(this._sessionStorageObject.currentPage)){
                            //Response was false, page was not found.  Clear from the session storage
                            this._sessionStorageObject.currentPage = 1;
                        }
                    }

                    //Check to see if a practice is selected
                    if (this._sessionStorageObject.selectedPracticeId) {
                        if (!this.practicesGrid.SelectRowByPayloadValue("practice_id", this._sessionStorageObject.selectedPracticeId)) {
                            //Response was false, row was not found.  Clear from the session storage
                            this._sessionStorageObject.selectedPracticeId = null;
                        }
                    }

                },
                50, 10
            );

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err) );
            this._markPageAsLoading(false);
            this._markGridAsLoading(false);
            this._setGridRows([]);
        });
        //NEW ------------------------------------


        //ORIGINAL -------------------------------------------------
        //this.webServices.GetPracticesListByRole("active")
        //.then((res) => {

        //    this._markPageAsLoading(false);
        //    this._markGridAsLoading(false);
        //    this._setGridRows(res.DTO);
        //    //this._sortGrid("practice_name", "A");

        //    //Wait for the grid to be rendered and then apply any session selections
        //    this.helpers.executeOnCondition(

        //        //When the grid is rendered...
        //        () => { return !!this.practicesGrid; },
                
        //        //Do this
        //        () => {  

        //            //Apply a sort
        //            this.practicesGrid.SortGrid(
        //                this._sessionStorageObject.sortColumn || "practice_name", 
        //                this._sessionStorageObject.sortDirection || "A"
        //            );

        //            //Check to see if we have a stored page to return to
        //            if (this._sessionStorageObject.currentPage) {
        //                if (!this.practicesGrid.SetPage(this._sessionStorageObject.currentPage)){
        //                    //Response was false, page was not found.  Clear from the session storage
        //                    this._sessionStorageObject.currentPage = 1;
        //                }
        //            }

        //            //Check to see if a practice is selected
        //            if (this._sessionStorageObject.selectedPracticeId) {
        //                if (!this.practicesGrid.SelectRowByPayloadValue("practice_id", this._sessionStorageObject.selectedPracticeId)) {
        //                    //Response was false, row was not found.  Clear from the session storage
        //                    this._sessionStorageObject.selectedPracticeId = null;
        //                }
        //            }

        //        },
        //        50, 10
        //    );

        //    ////If the grid is rendered, look for any sticky selections
        //    //if (this.practicesGrid) {

        //    //    //Check to see if a practice is selected
        //    //    if (this._sessionStorageObject.selectedPracticeId) {
        //    //        this.practicesGrid.SelectRowByPayloadValue("practice_id", this._sessionStorageObject.selectedPracticeId);
        //    //    }

        //    //    //Check to see if we have a stored page to return to
        //    //    if (this._sessionStorageObject.currentPage) {
        //    //        this.practicesGrid.SetPage(this._sessionStorageObject.currentPage);
        //    //    }
        //    //}
        //})
        //.catch((err) => { 
        //    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err) );
        //    this._markPageAsLoading(false);
        //    this._markGridAsLoading(false);
        //    this._setGridRows([]);
        //});
        //ORIGINAL -------------------------------------------------


    }


    // UI HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // NavBoxActionClicked
    //==================================
    NavBoxActionClicked( action ){

        switch( action.field_name ){

            case "act_view_narrative":
                if (!this.selectedPractice) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }
                this.router.navigate(["/cpdes/practices/narrativesList/" + this.selectedPractice.practice_id]);
                break;
        }
    }

    //==================================
    // onGridRefreshClicked
    //==================================
    onGridRefreshClicked(){
        this.LoadPractices();
    };

    //==================================
    // onGridSearch
    //==================================
    onGridSearch(searchText) {
        
        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0){
            this.practicesGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.practice_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.practicesGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //==================================
    // onPageChanged
    //==================================
    // $event will contain the new page
    onPageChanged($event) {

        var newPage = $event;
    
        //Store the new page in the local storage
        this._sessionStorageObject.currentPage = newPage;
        this._saveSessionStorageObject(this._sessionStorageObject);
    }

    //==================================
    // onRowSelectionChanged
    //==================================
    onRowSelectionChanged(){
        
        this.selectedPractice = this.practicesGrid.GetFirstSelectedRow();

        if (this.selectedPractice) {
            this._sessionStorageObject.selectedPracticeId = this.selectedPractice.practice_id;
            this._saveSessionStorageObject(this._sessionStorageObject);

        }
        else {
            this._sessionStorageObject.selectedPracticeId = null;
            this._saveSessionStorageObject(this._sessionStorageObject);
        }
    }

    //==================================
    // onSort
    //==================================
    onSort($event) {

        var column = $event;
    
        //Store the new page in the local storage
        this._sessionStorageObject.sortColumn = column.fieldName;
        this._sessionStorageObject.sortDirection = column.sorted;
        this._saveSessionStorageObject(this._sessionStorageObject);
    }


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _disableUI
    //==================================
    _disableUI(){
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    _enableUI(){
        this.casNavBoxService.EnableAllLinks();
        this._allFieldsDisabled = false;
    };

    //==================================
    // _getTitle
    //==================================
    _getTitle() {

        //No longer differentiated by  user
        return "Narratives Home - Assets";

        //if (authToken.IsNational()){
        //    this._title = "Narratives Home - Assets";
        //}
        //else if(authToken.IsState()){
        //    this._title = "Narratives Home - " + authToken.user.stateName + " - Assets";
        //}
    }

    //==================================
    // _handleGlobalKeypress
    //==================================
    //_handleGlobalKeypress(e){
    //};

    //==================================
    // _isLoading
    //==================================
    _isLoading() {
        return this._loading || this.casNavBoxService.ActionsLoading;
    }

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.practicesGrid){
            this.practicesGrid.MarkAsLoading(isLoading);
        }
        else{
            this.practicesGridSettings.loading = isLoading;
        }
    }

    //==================================
    // _markPageAsLoading
    //==================================
    _markPageAsLoading(isLoading) {
        this._loading = isLoading;
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_savesessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.practicesGridGrid){
            this.practicesGridGrid.SetRows(data);
        }
        else{
            this.practicesGridSettings.rows = data;
        }
    }

    //==================================
    // _sortGrid
    //==================================
    _sortGrid(column, direction) {

        // Let's give the grid a chance to render for a bit and then sort
        // once it comes up.  Keep it tight though, or we'll sort too long
        // after the grid comes up.
        this.helpers.executeOnCondition(
            () => { return !!this.practicesGrid; },
            () => { this.practicesGrid.SortGrid(column, direction); },
            50, 10
        );

    }


    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry){
        console.log("[narratives:_debugEntryClicked]");
        console.log("    ", entry);

        switch (entry){ 
            case "Dump Session Storage":
                console.log(this._sessionStorageObject);
                //this._executeOnCondition(
                //    () => { return false; },
                //    () => { console.log("TESTING:DONE"); },
                //    100, 7
                //);
        }
    };

}

// REMOVED
//-------------------------------------------------------------------------------------------------------------------------
// I want to keep some of these as they provide a good example of how to do things I may want to do again

    //==================================
    // _handleGlobalKeypress
    //==================================
    //_handleGlobalKeypress(e){

        //if (e.altKey && e.ctrlKey){

        //    switch(e.key.toLowerCase()){

        //        case "t":
        //            e.preventDefault();
        //            e.stopPropagation();

        //            //If a practice is selected, move the focus to the narratives grid
        //            let practice = this.practicesGrid.GetFirstSelectedRow(); //There will only be one

        //            if (practice){
        //                this.narrativesGrid.SetFocusToFirstRow();
        //            }

        //            break;

        //        case "i":
        //            e.preventDefault();
        //            e.stopPropagation();

        //            this.practicesGrid.SetFocusToFirstRow();

        //            break;
        //    }
        //}
    //};

